import React, { useState } from "react";
import { scaleLinear, line, curveNatural, path } from "d3";

import {
  Svg,
  Circle,
  Text,
  G,
  Path,
  Line,
  ClipPath,
  Rect,
  Defs,
} from "@react-pdf/renderer";

import "svg2pdf.js";

import { useTranslation } from "react-i18next";

const width = 550;

const height = 400;

const margin = { top: 62, right: 60, bottom: 60, left: 82 };
const xAxisLabelOffset = 30;
const yAxisLabelOffset = 30;
const x = 0;
const y = -10;

const innerHeight = height - margin.top - margin.bottom;
const innerWidth = width - margin.left - margin.right;

function FanChartReactPDF(props) {
  //Kalkulacija koeficijenta za kvadratnu jednacinu y=ax^2
  const factor =
    props.chartFile["pfs[Pa]"] / Math.pow(props.chartFile["qv [m^3/h]"], 2);

  let squaredCurve = [];

  //kreiranje niza koordinata za kvadratnu jednacinu na osnovu max vrednosti y ose
  for (
    let i = 0;
    i <
    +props.chartFile.psf_qv_100[props.chartFile.psf_qv_100.length - 1].Y + 200;
    i += 5
  ) {
    let x = Math.sqrt(i / factor);
    squaredCurve.push({ X: x, Y: i });
  }

  /*const [axisConfig, setAxisConfig] = useState({
    bottomMin: 0,
    bottomMax: +props.chartFile.psf_qv_100[0].X + 500,
    leftMin: 0,
    leftMax:
      +props.chartFile.psf_qv_100[props.chartFile.psf_qv_100.length - 1].Y + 50,
  });*/
  const axisConfig = {
    bottomMin: 0,
    bottomMax: +props.chartFile.psf_qv_100[0].X + 500,
    leftMin: 0,
    leftMax:
      +props.chartFile.psf_qv_100[props.chartFile.psf_qv_100.length - 1].Y + 50,
  };
  const [fanType, setFanType] = useState(
    props.type.substring(0, 3) === "ECF" ? "Standard" : "Premium"
  );
  var intersect = require("path-intersection");

  const xValue = (d) => d.X;

  const bottomAxis = "qv [m" + "\u00B3" + "/h]";
  const topAxis = "qv [cfm]";

  const yValue = (d) => d.Y;
  const leftAxis = "pfs [Pa]";
  const rightAxis = "pfs [in.wg]";

  const bottomScale = scaleLinear()
    .domain([axisConfig.bottomMin, axisConfig.bottomMax])
    .range([0, innerWidth])
    .nice();

  const topScale = scaleLinear()
    .domain([
      axisConfig.bottomMin * 0.58857777021102,
      axisConfig.bottomMax * 0.58857777021102,
    ])
    .range([0, innerWidth])
    .nice();

  const leftScale = scaleLinear()
    .domain([axisConfig.leftMin, axisConfig.leftMax])
    .range([innerHeight, 0])
    .nice();

  const rightScale = scaleLinear()
    .domain([axisConfig.leftMin * 0.00401865, axisConfig.leftMax * 0.00401865])
    .range([innerHeight, 0])
    .nice();

  let tickOffset = 15;

  //Kreiramo tacke za ravnu liniju
  const pfsPaPoints = [
    [0, leftScale(props.chartFile["pfs[Pa]"])],
    [innerWidth, leftScale(props.chartFile["pfs[Pa]"])],
  ];

  //kreiramo pravu liniju
  const pfsPaLine = path();
  pfsPaLine.moveTo(...pfsPaPoints[0]);
  pfsPaPoints.slice(1).forEach((point) => pfsPaLine.lineTo(...point));
  pfsPaLine.closePath();

  //Kreiramo tacke za ravnu X liniju
  const XLinePoints = [
    [0, bottomScale(props.chartFile["qv [m^3/h]"])],
    [innerWidth, bottomScale(props.chartFile["qv [m^3/h]"])],
  ];

  //kreiramo pravu liniju
  const qvLine = path();
  qvLine.moveTo(...XLinePoints[0]);
  XLinePoints.slice(1).forEach((point) => qvLine.lineTo(...point));
  qvLine.closePath();

  let psfQvOpLine = line()
    .x((d) => bottomScale(xValue(d)))
    .y((d) => leftScale(yValue(d)))
    .curve(curveNatural)(props.chartFile.pfs_qv_op);

  let lineSquareFunction = line()
    .x((d) => bottomScale(xValue(d)))
    .y((d) => leftScale(yValue(d)))
    .curve(curveNatural)(squaredCurve);

  //Presek operativne i kvadratne krive
  var intersectionSquareOperative = intersect(lineSquareFunction, psfQvOpLine);

  //koliko treba da pomerimo vrednosti u levo

  let xValueMingzhen = xValue;
  let yValueMingzhen = yValue;
  let psfQvOpLineLong = props.chartFile.pfs_qv_op;
  if (intersectionSquareOperative.length > 0) {
    //Trazimo razmak izmedju X vrednosti preseka operativne i kvadratne krive i QV linije
    const razmakX =
      props.chartFile["qv [m^3/h]"] -
      bottomScale.invert(intersectionSquareOperative[0].x);
    //Trazimo razmak izmedju Y vrednosti preseka operativne i kvadratne krive i PsfPa linije
    const razmakY =
      leftScale.invert(intersectionSquareOperative[0].y) -
      props.chartFile["pfs[Pa]"];

    xValueMingzhen = (d) => +d.X + razmakX;
    yValueMingzhen = (d) => +d.Y - razmakY;
    psfQvOpLineLong = [
      {
        X: String(parseInt(props.chartFile.pfs_qv_op[0].X) + razmakX / 2),
        Y: String(parseInt(props.chartFile.pfs_qv_op[0].Y) + razmakY),
      },
    ].concat(props.chartFile.pfs_qv_op);
  }

  return (
    <Svg width={width} height={height} id="svg" debug="true">
      <Defs>
        <ClipPath id="clipPath">
          <Rect x="0" y="0" width={innerWidth} height={innerHeight} />
        </ClipPath>
      </Defs>
      <G transform={`translate(${margin.left},${margin.top})`}>
        {bottomScale.ticks(10).map((tickValue, index) => (
          <G key={tickValue}>
            <Line
              stroke="#D3D3D3"
              stroke-width="1"
              stroke-linecap="butt"
              x1={bottomScale(tickValue)}
              x2={bottomScale(tickValue)}
              y1={innerHeight}
              y2={0}
            />
            {index % 2 !== 0 && (
              <Text
                transform={`translate(${bottomScale(
                  tickValue
                )},${innerHeight})`}
                style={{ textAnchor: "middle", fontSize: "10px" }}
                y={tickOffset}
              >
                {tickValue}
              </Text>
            )}
          </G>
        ))}
        <Text
          style={{ fontSize: "10px" }}
          transform={`translate(${innerWidth / 2},${
            innerHeight + xAxisLabelOffset
          })`}
        >
          {bottomAxis}
        </Text>

        {topScale.ticks(5).map((tickValue) => (
          <G key={tickValue} transform={`translate(${topScale(tickValue)},0)`}>
            <Text
              style={{ textAnchor: "middle", fontSize: "10px" }}
              y={-tickOffset}
            >
              {tickValue}
            </Text>
          </G>
        ))}
        <Text
          textAnchor="middle"
          transform={`translate(${innerWidth / 2},${-xAxisLabelOffset})`}
          style={{ fontSize: "10px" }}
        >
          {topAxis}
        </Text>
        {leftScale.ticks(15).map((tickValue) => (
          <G key={tickValue}>
            <Line
              stroke="#D3D3D3"
              stroke-width="1"
              stroke-linecap="butt"
              x1={0}
              x2={innerWidth}
              y1={leftScale(tickValue)}
              y2={leftScale(tickValue)}
            />

            <Text
              transform={`translate(0,${leftScale(tickValue)})`}
              style={{ textAnchor: "middle", fontSize: "10px" }}
              x={-tickOffset}
              y={2}
            >
              {tickValue}
            </Text>
          </G>
        ))}
        <Text
          style={{ fontSize: "10px" }}
          transform={`translate(${-xAxisLabelOffset},${
            innerHeight / 2
          }) rotate(-90)`}
        >
          {leftAxis}
        </Text>
        {rightScale.ticks(15).map((tickValue) => (
          <G key={tickValue}>
            <Text
              style={{ textAnchor: "middle", fontSize: "10px" }}
              x={tickOffset}
              transform={`translate(${innerWidth},${rightScale(tickValue)})`}
              // y={4}
            >
              {tickValue}
            </Text>
          </G>
        ))}
        <Text
          style={{ fontSize: "10px" }}
          textAnchor="middle"
          transform={`translate(${innerWidth + yAxisLabelOffset},${
            innerHeight / 2
          }) rotate(90)`}
        >
          {rightAxis}
        </Text>

        <Line
          stroke="blue"
          stroke-width="1"
          stroke-dasharray="3 1"
          stroke-dashoffset="1"
          y1={leftScale(props.chartFile["pfs[Pa]"])}
          y2={leftScale(props.chartFile["pfs[Pa]"])}
          x1={0}
          x2={innerWidth}
        />
        <Line
          stroke="blue"
          stroke-width="1"
          stroke-dasharray="3 1"
          stroke-dashoffset="1"
          y1={0}
          y2={innerHeight}
          x1={bottomScale(props.chartFile["qv [m^3/h]"])}
          x2={bottomScale(props.chartFile["qv [m^3/h]"])}
        />
        {fanType === "Premium" ? (
          <G>
            <Path
              fill="none"
              stroke="red"
              d={line()
                .x((d) => bottomScale(xValue(d)))
                .y((d) => leftScale(yValue(d)))
                .curve(curveNatural)(
                props.chartFile.psf_qv_op_Bsp.psf_qv_op_Bsp
              )}
            ></Path>
            {props.chartFile.pfs_qv_op.map((point) => (
              <Circle
                fill="red"
                cx={bottomScale(xValue(point))}
                cy={leftScale(yValue(point))}
                r={2}
              ></Circle>
            ))}
          </G>
        ) : (
          <G clipPath="url(#clipPath)">
            <Path
              fill="none"
              stroke="red"
              d={line()
                .x((d) => bottomScale(xValueMingzhen(d)))
                .y((d) => leftScale(yValueMingzhen(d)))
                .curve(curveNatural)(psfQvOpLineLong)}
            ></Path>

            {psfQvOpLineLong.map((point) => (
              <Circle
                fill="red"
                cx={bottomScale(xValueMingzhen(point))}
                cy={leftScale(yValueMingzhen(point))}
                r={2}
              ></Circle>
            ))}
            {/* KRIVA 8V
            <Path
              fill="none"
              stroke="purple"
              d={line()
                .x((d) => bottomScale(xValue(d)))
                .y((d) => leftScale(yValue(d)))
                .curve(curveNatural)(
                props.chartFile.psf_qv_op_Bsp.psf_qv_op_Bsp
              )}
            ></Path>

            {props.chartFile.pfs_qv_op.map((point) => (
              <Circle
                fill="purple"
                cx={bottomScale(xValue(point))}
                cy={leftScale(yValue(point))}
                r={2}
              ></Circle>
            ))}
             kraj krive 8V*/}
          </G>
        )}
        <G>
          <Path
            fill="none"
            stroke="red"
            d={line()
              .x((d) => bottomScale(xValue(d)))
              .y((d) => leftScale(yValue(d)))
              .curve(curveNatural)(
              props.chartFile.psf_qv_100_Bsp.psf_qv_100_Bsp
            )}
          ></Path>
          {props.chartFile.psf_qv_100.map((point) => (
            <Circle
              fill="red"
              cx={bottomScale(xValue(point))}
              cy={leftScale(yValue(point))}
              r={2}
            ></Circle>
          ))}
          <Path
            fill="none"
            stroke="black"
            clipPath="url(#clipPath)"
            d={lineSquareFunction}
          ></Path>
        </G>
        <Text
          style={{ fontSize: "10px" }}
          textAnchor="middle"
          x={bottomScale(props.chartFile["qv [m^3/h]"])}
          y={leftScale(props.chartFile["pfs[Pa]"]) - 5}

          /* transform={`translate(${innerWidth + yAxisLabelOffset},${
            innerHeight / 2
          }) rotate(90)`}*/
        >
          {Number(props.chartFile["qv [m^3/h]"]).toFixed(0) +
            "m" +
            "\u00B3" +
            "/h @" +
            Number(props.chartFile["pfs[Pa]"]).toFixed(0) +
            " Pa"}
        </Text>
        <Circle
          fill="black"
          cx={bottomScale(props.chartFile["qv [m^3/h]"])}
          cy={leftScale(props.chartFile["pfs[Pa]"])}
          r={2}
        ></Circle>
        {/*<Text
          style={{ fontSize: "10px" }}
          textAnchor="middle"
          x={intersectionOperatingAndMax[0].x}
          y={intersectionOperatingAndMax[0].y - 5}

     
        >
          {Math.round(bottomScale.invert(intersectionOperatingAndMax[0].x)) +
            "m" +
            "\u00B3" +
            "/h @" +
            Math.round(leftScale.invert(intersectionOperatingAndMax[0].y)) +
            " Pa"}
        </Text>
        <Circle
          fill="black"
          cx={intersectionOperatingAndMax[0].x}
          cy={intersectionOperatingAndMax[0].y}
          r={2}
          ></Circle>*/}
      </G>
    </Svg>
  );
}

export default FanChartReactPDF;
